import { RoleTypeEnum } from 'src/enums/roleTypeEnum';
import { Role } from 'src/types/ViewModel/Role';
import { stowageFeatureEnum } from 'src/enums/stowage/stowageFeatureEnum';

// Ref. https://dev.azure.com/odfjell/Odfjell/_wiki/wikis/Odfjell.wiki/608/Roles-and-permissions
const stowagePermissions = [
    { feature: stowageFeatureEnum.ViewStowagePlan, roles: [RoleTypeEnum.ShipOperator, RoleTypeEnum.ShipUser, RoleTypeEnum.FleetPerformanceAnalyst, RoleTypeEnum.OtherOdfjellUser] },
    { feature: stowageFeatureEnum.EditStowage, roles: [RoleTypeEnum.ShipOperator, RoleTypeEnum.ShipUser] },
    { feature: stowageFeatureEnum.EditShipFigure, roles: [RoleTypeEnum.ShipUser] },
    { feature: stowageFeatureEnum.Publish, roles: [RoleTypeEnum.ShipOperator] },
    { feature: stowageFeatureEnum.Promote, roles: [RoleTypeEnum.ShipUser] },
    { feature: stowageFeatureEnum.SynchronizeWithImos, roles: [RoleTypeEnum.ShipOperator] },
    { feature: stowageFeatureEnum.GenerateReport, roles: [RoleTypeEnum.ShipOperator, RoleTypeEnum.ShipUser, RoleTypeEnum.OtherOdfjellUser] },
    { feature: stowageFeatureEnum.AdjustCargoTemperature, roles: [RoleTypeEnum.ShipOperator, RoleTypeEnum.ShipUser] },
    { feature: stowageFeatureEnum.BlockTank, roles: [RoleTypeEnum.ShipOperator, RoleTypeEnum.ShipUser] },
    { feature: stowageFeatureEnum.AcceptSoftRuleViolation, roles: [RoleTypeEnum.ShipOperator, RoleTypeEnum.ShipUser] },
    { feature: stowageFeatureEnum.AutoStow, roles: [] },
    { feature: stowageFeatureEnum.EmptyTankPlan, roles: [RoleTypeEnum.ShipOperator, RoleTypeEnum.ShipUser] },
    { feature: stowageFeatureEnum.EditRotation, roles: [RoleTypeEnum.ShipOperator, RoleTypeEnum.ShipUser] },
    { feature: stowageFeatureEnum.EditCargo, roles: [RoleTypeEnum.ShipOperator, RoleTypeEnum.ShipUser] },
];

export const hasPermission = (role: Role, feature: stowageFeatureEnum): boolean => {
    return (
        role.roleType !== RoleTypeEnum.Unknown &&
        (role.roleType === RoleTypeEnum.Admin || (stowagePermissions.find((p) => p.feature === feature)?.roles.includes(role.roleType) ?? false))
    );
};

export const hasAnyPermission = (role: Role, features: stowageFeatureEnum[]): boolean => {
    return features.some((feature) => hasPermission(role, feature));
};

export const hasAllPermissions = (role: Role, features: stowageFeatureEnum[]): boolean => {
    return features.every((feature) => hasPermission(role, feature));
};
